export const generateRandomNumber = () => {
    const randomNum = Math.floor(Math.random() * 9999) + 1; // Generates a number between 1 and 9999
    return randomNum.toString().padStart(4, '0'); // Pads the number with leading zeros to ensure it's 4 digits
};